import { defineComponent } from 'vue'
import { BlockModule } from '@/website/blocks/common'
import {
    Accordion,
    AccordionTrigger,
    AccordionContent,
    AccordionItem,
} from '@/components/ui/accordion'

new BlockModule({
    selector: '.block-accordion',
    vueComponent: defineComponent({
        components: {
            Accordion,
            AccordionTrigger,
            AccordionContent,
            AccordionItem,
        },
        setup() {},
    }),
})
